import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0908Model } from './kymw0908.model';
import { KYMW0908InputModel } from './vo/kymw0908-input.model';
import { KYMW0908OutputModel } from './vo/kymw0908-output.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { VersatileComboBoxComponent } from '../../kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';
import { GetCouponGoodsNoService } from './api-services/get-coupon-goods-no.service';
import { CodeComboBoxComponent } from '../../kymw02/combo-box/code-combo-box/code-combo-box.component';

/**
 * クーポン商品プロモーション設定画面を管理するクラス
 *
 * @export KYMW0908Component
 * @class KYMW0908Component
 */
@Component({
  selector: 'app-kymw0908',
  templateUrl: 'kymw0908.component.html',
  styleUrls: ['kymw0908.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0908Component extends PlessViewHelperSub implements OnInit {
  param: any;
  setKYMW0908Parameter: Function;
  kymw0908Model: KYMW0908Model = new KYMW0908Model();
  
  // 取扱可能生協
  public enableCoopList = [];

  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VersatileComboBoxComponent;
  @ViewChild('dtg_CouponApplicablePriceList', { static: true }) dtg_CouponApplicablePriceList: FlexGrid;
  @ViewChild('cmb_CouponTypeList', { static: true }) cmb_CouponTypeList: CodeComboBoxComponent;
  @ViewChild('cmb_GroupTypeList', { static: true }) cmb_GroupTypeList: CodeComboBoxComponent;
  @ViewChild('txti_CouponDiscountUnitPrice', { static: true }) txti_CouponDiscountUnitPrice: ElementRef;
  @ViewChild('txti_CouponDiscountRate', { static: true }) txti_CouponDiscountRate: ElementRef;
  @ViewChild('txti_CouponNameKana', { static: true }) txti_CouponNameKana: ElementRef;
  @ViewChild('txti_CouponGuideNameKana', { static: true }) txti_CouponGuideNameKana: ElementRef;

  closeFunction: Function;

  isComposing = false;

  /**
   *Creates an instance of KYMW0908Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0908Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getCouponGoodsNo: GetCouponGoodsNoService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0908';

    this.dtg_CouponApplicablePriceList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_CouponApplicablePriceList.hitTest(e);
      if ((0 == ht.row) && (0 == ht.col) && ht.target.className === 'all-target_list-checkbox') {
        document.getElementById(`coupon_applicable_price_list_all_check`).click();
      } else if ((0 <= ht.row) && (0 == ht.col) && !ht.target.className.includes('headear-checkbox')) {
        document.getElementById(`coupon_applicable_price_list_check_${ht.row}`).click();
      }
    });

    // 全選択チェック
    this.setCoopAllCheck();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   */
  public setInterfaceParam(param: KYMW0908InputModel): void {
    this.kymw0908Model.mode = param.mode;
    if (this.isAddMode()) {
      // kymw0900から値を受け取る
      this.kymw0908Model.coopInfoItemCoopCode = param.coopInfoItemCoopCode;
      this.kymw0908Model.itemCodeList = param.itemCodeList;
      this.kymw0908Model.selectedItemCode = param.selectedItemCode;
      this.kymw0908Model.couponOrderNumQuotaCodeList = param.couponOrderNumQuotaCodeList;
      this.kymw0908Model.couponOrderNumQuotaCode = param.couponOrderNumQuotaCode;
      this.kymw0908Model.couponName = param.couponName;
      this.kymw0908Model.couponNameKana = param.couponNameKana;
      this.kymw0908Model.couponGuideName = param.couponGuideName;
      this.kymw0908Model.couponGuideNameKana = param.couponGuideNameKana;
      // 商品名・規格に値を設定する
      this.kymw0908Model.contentOne = this.setContentOne(param.couponName, param.couponGuideName);
      this.kymw0908Model.validatedDate = param.validatedDate;
      this.kymw0908Model.registFlg = param.registFlg;
      this.kymw0908Model.deleteFlg = param.deleteFlg;
      this.kymw0908Model.couponApplicablePriceList = param.couponApplicablePriceList;
      this.kymw0908Model.consumeTaxDiv = param.consumeTaxDiv;
      this.kymw0908Model.consumeTaxDivRate = param.consumeTaxDivRate;
      this.kymw0908Model.itemRelatedCoop = param.itemRelatedCoop;
      this.kymw0908Model.settedItemGroup = param.settedItemGroup;
      // 値引き前本体価格・税込み価格に値を設定する
      const coopIndexList = this.getCoopCheckbox(); 
      // 会員生協別値引情報一覧のチェックボックスONが存在する場合「供給単価 + (供給単価 * 消費税率)」の値を表示    
      if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
        // 全生協の企画商品クーポン利用生協情報フラグが「1」ではない場合、
        // 値引き前本体価格・税込み価格には空欄を設定する
        this.kymw0908Model.contentTwo = '';
      } else {
        // 優先度が高い生協の供給単価のカンマを外してnumber型にする
        const supplyPrice = PlessViewUtilsSub.stringToNumber(
          PlessViewUtilsSub.editPriceComma(this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndexList[0])?.thisTimeSupplyPrice, false)
        );
        // 消費税
        const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(param.consumeTaxDivRate) * 0.01;
        // 「供給単価 + (供給単価 * 消費税率)」の値を計算。小数点以下は切り下げ
        this.kymw0908Model.contentTwo = this.kymw0908Model.formatUnitRatePrice(supplyPrice, consumeTaxDivRate);
      }
    } else if (this.isDetailMode() || this.isReadOnlyMode()) {
      // kymw0900から値を受け取る
      this.kymw0908Model.coopInfoItemCoopCode = param.coopInfoItemCoopCode;
      this.kymw0908Model.couponGoodsNo = param.couponGoodsNo;
      this.kymw0908Model.selectedItemCode = param.selectedItemCode;
      this.kymw0908Model.itemCodeList = param.itemCodeList;
      this.kymw0908Model.couponType = param.couponType;
      this.kymw0908Model.couponOrderNumQuotaCode = param.couponOrderNumQuotaCode;
      this.kymw0908Model.couponOrderNumQuotaCodeList = param.couponOrderNumQuotaCodeList;
      this.kymw0908Model.notificationFlg = param.notificationFlg;
      this.kymw0908Model.staffCouponFlg = param.staffCouponFlg === '1';
      this.kymw0908Model.couponName = param.couponName;
      this.kymw0908Model.couponNameKana = param.couponNameKana;
      this.kymw0908Model.couponGuideName = param.couponGuideName;
      this.kymw0908Model.couponGuideNameKana = param.couponGuideNameKana;
      this.kymw0908Model.groupType = param.groupType;
      this.kymw0908Model.couponOrderNum = param.couponOrderNum;
      this.kymw0908Model.deliveryFlg = param.deliveryFlg === '1';
      this.kymw0908Model.newsletterFlg = param.newsletterFlg === '1';
      this.kymw0908Model.couponDiscountType = param.couponDiscountType;
      this.kymw0908Model.couponDiscountUnitPrice = param.couponDiscountUnitPrice;
      this.kymw0908Model.couponDiscountRate = param.couponDiscountRate;
      this.kymw0908Model.couponLimitNum = param.couponLimitNum;
      this.kymw0908Model.couponTitleEc = param.couponTitleEc;
      this.kymw0908Model.couponTitleDelivery = param.couponTitleDelivery;
      this.kymw0908Model.validatedDate = param.validatedDate;
      this.kymw0908Model.registFlg = param.registFlg;
      this.kymw0908Model.deleteFlg = param.deleteFlg;
      this.kymw0908Model.couponApplicablePriceList = param.couponApplicablePriceList;
      this.kymw0908Model.consumeTaxDiv = param.consumeTaxDiv;
      this.kymw0908Model.consumeTaxDivRate = param.consumeTaxDivRate;
      this.kymw0908Model.itemRelatedCoop = param.itemRelatedCoop;

      // 設定済みのアイテムコードとグループの組み合わせリストから指定のアイテムコード・グループのセットを削除
      // 設定ボタン押下時に登録済みバリデーションの対象から除外するため
      this.kymw0908Model.settedItemGroup = param.settedItemGroup.filter(e => {
        if (e.itemCode === param.selectedItemCode && e.groupType === param.groupType) {
          return false;
        } else {
          return true;
        }
      });

      this.kymw0908Model.couponApplicablePriceList.map(_ => {
        // 値引後単価（discountedUnitPrice）を算出し、計算結果を設定する
        // 値引後単価の計算時は小数点以下を切り捨てとする
        let resultPrice = '';
        // 供給単価のカンマを外す
        let supplyPriceWithoutComma = PlessViewUtilsSub.editPriceComma(_.thisTimeSupplyPrice, false);
        supplyPriceWithoutComma = supplyPriceWithoutComma ? supplyPriceWithoutComma : '0';

        if (!PlessViewUtilsSub.isEmpty(_.discountUnitPrice) && PlessViewUtilsSub.isEmpty(_.discountRate)) {
          // 値引単価があり、値引率がない場合：供給単価 - 値引単価
          const result = Number(supplyPriceWithoutComma) - Number(_.discountUnitPrice);
          resultPrice = String(Math.ceil(result));
        } else if (PlessViewUtilsSub.isEmpty(_.discountUnitPrice) && !PlessViewUtilsSub.isEmpty(_.discountRate)) {
          // 値引率があり、値引単価がない場合：供給単価 - （供給単価 * 値引率 * 0.01）
          const result = Number(supplyPriceWithoutComma) - (Number(supplyPriceWithoutComma) * Number(_.discountRate) * 0.01);
          resultPrice = String(Math.ceil(result));
        } else if (PlessViewUtilsSub.isEmpty(_.discountUnitPrice) && PlessViewUtilsSub.isEmpty(_.discountRate)) {
          // 値引単価と値引率がどちらもない場合は空欄（空白）で表示する
          resultPrice = '';
        }
        // 【表示形式】n,nnn,nnnに変換
        _.discountedUnitPrice = PlessViewUtilsSub.editPriceComma(resultPrice, true);
      });

      // contentOne:商品名・規格に値を設定する
      if (!PlessViewUtilsSub.isEmpty(param.contentOne)) {
        // 取得した内容1がnullではない場合：取得した内容1を表示
        // 全角スペース埋めを行う
        this.kymw0908Model.contentOne = this.parent.contentOneSpacePadding(param.contentOne);
      } else {
        // nullの場合はクーポン名、クーポン規格名から設定
        this.kymw0908Model.contentOne = this.setContentOne(param.couponName, param.couponGuideName);
      }

      // 供給単価は取得した企画商品クーポン利用生協情報フラグが「1」になっている生協のうち、優先度が高い生協の供給単価を使用する
      const coopIndexList = this.getCoopCheckbox();

      // contentTwo:値引き前本体価格・税込み価格に値を設定する
      if (!PlessViewUtilsSub.isEmpty(param.contentTwo)) {
        // 取得した内容2がnullではない場合：取得した内容2を表示
        this.kymw0908Model.contentTwo = param.contentTwo;
      } else {
        // 取得した内容2がnullの場合：「供給単価 + (供給単価 * 消費税率)」の値を表示        
        if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
          // 全生協の企画商品クーポン利用生協情報フラグが「1」ではない場合、
          // 値引き前本体価格・税込み価格には空欄を設定する
          this.kymw0908Model.contentTwo = '';
        } else {
          // 優先度が高い生協の供給単価のカンマを外してnumber型にする
          const supplyPrice = PlessViewUtilsSub.stringToNumber(
            PlessViewUtilsSub.editPriceComma(this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndexList[0])?.thisTimeSupplyPrice, false)
          );
          // 消費税
          const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(param.consumeTaxDivRate) * 0.01;
          // 「供給単価 + (供給単価 * 消費税率)」の値を計算。小数点以下は切り下げ
          this.kymw0908Model.contentTwo = this.kymw0908Model.formatUnitRatePrice(supplyPrice, consumeTaxDivRate);
        }
      }

      // contentThree:値引内容に値を設定する
      if (PlessViewUtilsSub.isEmpty(param.contentThree)) {
        if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
          // 全生協の値引単価、値引率に値がない場合は空欄を設定する
          this.kymw0908Model.contentThree = '';
        } else {
          // 値引単価・値引率が複数ある場合は、優先度で表示制御を行う。		
          for (const coopIndex of coopIndexList) {
            if (!PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndex)?.discountUnitPrice)) {
              // 取得した内容3がnull かつ 取得した値引単価に値がある場合：「[値引単価]円引きクーポン」を表示
              this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndex)?.discountUnitPrice) + KYMW0908Model.DISCOUNT_UNIT_PRICE_SUFFIX;
              break;
            } else if (!PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndex)?.discountRate)) {
              // 取得した内容3がnull かつ 取得した値引率に値がある場合：「[値引率]%引きクーポン」を表示
              this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndex)?.discountRate) + KYMW0908Model.DISCOUNT_RATE_SUFFIX;
              break;
            }
          }
        }
      } else {
        // 取得した内容3がnullではない場合：取得した内容3を表示
        this.kymw0908Model.contentThree = param.contentThree;
      }

      // contentFour:値引き後本体価格・税込み価格に値を設定する
      // 取得した内容4がnullの場合：空欄	
      // 取得した内容4がnullではない場合：取得した内容4を表示	
      this.kymw0908Model.contentFour = PlessViewUtilsSub.nullToBlank(param.contentFour);

      if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponTitleDelivery)) {
        // タイトル（お届け明細）が空の場合、条件を満たせば制限数から値を設定する
        this.setCouponTitleDelivery();
      }
    }
  }

  /**
   * 追加モードか判定
   */
  public isAddMode(): boolean {
    return this.kymw0908Model.mode === KYMW0908InputModel.MODE_ADD;
  }

  /**
   * 詳細モードか判定
   */
  public isDetailMode(): boolean {
    return this.kymw0908Model.mode === KYMW0908InputModel.MODE_DETAIL;
  }

  /**
   * 閲覧モードか判定
   */
  public isReadOnlyMode(): boolean {
    return this.kymw0908Model.mode === KYMW0908InputModel.MODE_READ_ONLY;
  }

  /**
   * 商品名・規格の値を設定
   * @param couponName クーポン名
   * @param couponGuideName クーポン規格名
   */
  public setContentOne(couponName: string, couponGuideName: string): string {
    let contentOne = '';
    if (!PlessViewUtilsSub.isEmpty(couponName) && !PlessViewUtilsSub.isEmpty(couponGuideName)) {
      // クーポン名、クーポン規格名がnullまたは空文字ではない場合：クーポン名、クーポン規格名を「　(全角スペース)」つなぎで連結して表示
      contentOne = couponName + '　' + couponGuideName;
    } else if (PlessViewUtilsSub.isEmpty(couponName)) {
      // クーポン名がnullもしくは空文字の場合：クーポン規格名を表示する
      contentOne = couponGuideName;
    } else if (PlessViewUtilsSub.isEmpty(couponGuideName)) {
      // クーポン規格名がnullもしくは空文字の場合：クーポン名を表示する
      contentOne = couponName;
    } else if (PlessViewUtilsSub.isEmpty(couponName) && PlessViewUtilsSub.isEmpty(couponGuideName)) {
      // クーポン名、クーポン規格名の両方がnullもしくは空文字の場合：空欄で表示する
      contentOne = '';
    }

    // 全角スペース埋めを行う
    contentOne = this.parent.contentOneSpacePadding(contentOne);

    return contentOne;
  }

  /**
   * 会員生協別割引情報一覧.チェックボックス判定
   * (優先大) ち > さ > とう > い > と > ぐ > な > に
   */
  public getCoopCheckbox(): Array<number> {
    // 優先大
    const priorityOrder = [
      this.kymw00Model.COOP_CODE_TI, // ちば
      this.kymw00Model.COOP_CODE_SA, // さいたま
      this.kymw00Model.COOP_CODE_TK, // とうきょう
      this.kymw00Model.COOP_CODE_IB, // いばらき
      this.kymw00Model.COOP_CODE_TO, // とちぎ
      this.kymw00Model.COOP_CODE_GU, // ぐんま
      this.kymw00Model.COOP_CODE_NA, // ながの
      this.kymw00Model.COOP_CODE_NI, // にいがた
    ];

    // 選択済み要素を優先大にソートし、元のインデックスリストを生成
    let coopIndexList = this.kymw0908Model.couponApplicablePriceList
      .map((item) => ({ ...item }))
      .filter((item) => item.planGoodsCoopCouponApplicablePriceFlg)
      .sort((a, b) => priorityOrder.indexOf(a.coopCode) - priorityOrder.indexOf(b.coopCode))
      .map((item) => item.coopCode);

    return coopIndexList;
  }

  /**
   * 共通イベントリスナ
   * 特定の処理がないイベントハンドラで使用、更新フラグを立てる
   */
  public common_CHANGEHandler(): void {
    this.kymw0908Model.isEdited = true;
  }

  /**
   * アイテムコードイベントリスナ
   */
  public eventItemCode_CHANGEHandler(): void {
    // ＜ON/OFF制御＞
    // 選択したアイテムコードが「会員」タブで選択されている場合、チェックボックスON・選択されていない場合チェックボックスOFF
    const coopInfoItemCoopCode = this.kymw0908Model.coopInfoItemCoopCode.find(_ => _.itemCode === this.kymw0908Model.selectedItemCode)?.coopCode;

    this.kymw0908Model.couponApplicablePriceList.map(c => {
      // ＜ON/OFF制御＞
      c.planGoodsCoopCouponApplicablePriceFlg = !PlessViewUtilsSub.isEmptyArray(coopInfoItemCoopCode) ? coopInfoItemCoopCode.includes(c.coopCode) : false;
    });

    this.setCoopAllCheck();
    this.eventcouponApplicablePriceListChk_CLICKHandler();
  }

  /**
   * 全選択チェックボックス制御
   */
  public setCoopAllCheck(): void {
    // すべてのチェックボックスがONの場合、全選択チェックボックスをON
    let flg = true;
    for (const c of this.kymw0908Model.couponApplicablePriceList) {
      if (!c.planGoodsCoopCouponApplicablePriceFlg) {
        flg = false;
        break;
      }
    }
    this.kymw0908Model.checkAll = flg;
  }

  /**
   * 全選択チェックイベントリスナ
   */
  public eventAllCoop_CLICKHandler(): void {
    const flg = this.kymw0908Model.checkAll;
      // 一括でチェックON、OFFする
      this.kymw0908Model.couponApplicablePriceList.map(_ => {
        // 価格一覧で活性となっている生協に対して
        // 全選択のチェックと同じ状態にする。
        _.planGoodsCoopCouponApplicablePriceFlg = !_.disable && flg;
      })

    this.eventcouponApplicablePriceListChk_CLICKHandler();
  }

  /**
   * 「閉じる」
   */
  public eventClose_CLICKHandler(): void {
    this.closeFunction();
  }

  /**
   * 設定ボタンを押下したときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSet_CLICKHandler(): void {
    // 選定後、クーポン種別とグループ種別は空で設定されているため、
    // 初期値として画面上に選択されている値を保持用パラメータに格納する
    this.kymw0908Model.couponType = this.cmb_CouponTypeList.selectedCodeValue;
    this.kymw0908Model.groupType = this.cmb_GroupTypeList.selectedCodeValue;

    if (!this.validate()) {
      return;
    }

    // クーポン商品プロモーション設定モーダルの呼び出し元確認
    if (this.isAddMode()) {
      // 追加ボタン押下より、遷移した場合、クーポン商品連番採番取得を行う
      this.getCouponGoodsNo.execute(data =>{
        this.kymw0908Model.couponGoodsNo = data.CouponGoodsNo;
        // 編集した内容で、クーポン商品プロモーション設定情報一覧に行を追加する
        this.setParamsAndClose();
      });
    } else if (this.isDetailMode()) {
      // 編集した内容で、クーポン商品プロモーション設定情報一覧の内容を更新する
      this.setParamsAndClose()
    }
  }

  /**
   * 値をセットしてモーダルを閉じるメソッド
   */
  public setParamsAndClose(): void {
    // 親画面に反映
    const vo = new KYMW0908OutputModel();
    vo.couponGoodsNo = this.kymw0908Model.couponGoodsNo;
    vo.selectedItemCode = this.kymw0908Model.selectedItemCode;
    vo.couponType = this.kymw0908Model.couponType;
    vo.couponTypeName = this.cmb_CouponTypeList.selectedCodeName;
    vo.couponOrderNumQuotaCode = this.kymw0908Model.couponOrderNumQuotaCode;
    vo.notificationFlg = this.kymw0908Model.notificationFlg;
    vo.notificationFlgName = this.kymw0908Model.notificationFlgList.find(_ => _.CodeValue === vo.notificationFlg).CodeName;
    vo.staffCouponFlg = this.kymw0908Model.staffCouponFlg ? '1' : '0';
    vo.couponName = this.kymw0908Model.couponName;
    vo.couponNameKana = this.kymw0908Model.couponNameKana;
    vo.couponGuideName = this.kymw0908Model.couponGuideName;
    vo.couponGuideNameKana = this.kymw0908Model.couponGuideNameKana;
    vo.groupType = this.kymw0908Model.groupType;
    vo.couponOrderNum = this.kymw0908Model.couponOrderNum;
    vo.deliveryFlg = this.kymw0908Model.deliveryFlg ? '1' : '0';
    vo.deliveryFlgName = this.kymw0908Model.deliveryFlg ? '有' : '無';
    vo.newsletterFlg = this.kymw0908Model.newsletterFlg ? '1' : '0';
    vo.newsletterFlgName = this.kymw0908Model.newsletterFlg ? '有' : '無';
    vo.couponDiscountType = this.kymw0908Model.couponDiscountType;
    vo.couponDiscountUnitPrice = this.kymw0908Model.couponDiscountUnitPrice;
    vo.couponDiscountRate = this.kymw0908Model.couponDiscountRate;
    vo.couponLimitNum = this.kymw0908Model.couponLimitNum;
    vo.couponApplicablePriceList = this.kymw0908Model.couponApplicablePriceList;
    vo.couponTitleEc = this.kymw0908Model.couponTitleEc;
    vo.couponTitleDelivery = this.kymw0908Model.couponTitleDelivery;
    vo.contentOne = this.kymw0908Model.contentOne;
    vo.contentTwo = this.kymw0908Model.contentTwo;
    vo.contentThree = this.kymw0908Model.contentThree;
    vo.contentFour = this.kymw0908Model.contentFour;
    vo.validatedDate = this.kymw0908Model.validatedDate;
    vo.registFlg = this.kymw0908Model.registFlg;
    vo.deleteFlg = this.kymw0908Model.deleteFlg;
    this.setKYMW0908Parameter(vo);

    this.closeFunction();
  }

  /**
   * 設定ボタン押下時のバリデーション
   */
  private validate(): boolean {
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.selectedItemCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['アイテムコード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponType)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['クーポン種別']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.groupType)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['グループ種別']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponOrderNumQuotaCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['クーポン注文コード割当コード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.notificationFlg)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['通知有無区分']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponName)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['クーポン名']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponNameKana)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['クーポン名（カナ）']);
      return false;
    }
    // 会員生協別値引情報一覧のチェックがついている行は値引単価または値引率が必須
    for (const c of this.kymw0908Model.couponApplicablePriceList) {
      if (c.planGoodsCoopCouponApplicablePriceFlg) {
        if (PlessViewUtilsSub.isEmpty(c.discountUnitPrice) && PlessViewUtilsSub.isEmpty(c.discountRate)) {
          this.dialogServiceSub.openAlertGetMessage('W0001', ['値引単価または値引率']);
          return false;
        }
      }
    }
    // 通知有無区分が"1（通知あり）の場合、通知方法(お届け明細)または通知方法(メルマガ)が必須
    if (this.kymw0908Model.notificationFlg === '1') {
      if (!this.kymw0908Model.deliveryFlg && !this.kymw0908Model.newsletterFlg) {
        this.dialogServiceSub.openAlertGetMessage('W0001', ['通知方法(お届け明細)または通知方法(メルマガ)']);
        return false;
      }
    }
    // グループが「9:設定無し」以外かつ登録・設定済みのグループ、アイテムコードの組み合わせを設定している場合
    if (this.kymw0908Model.groupType !== '9') {
      for (const d of this.kymw0908Model.settedItemGroup) {
        if (d.itemCode === this.kymw0908Model.selectedItemCode && d.groupType === this.kymw0908Model.groupType) {
          this.dialogServiceSub.openAlertGetMessage('E0115', ['同一グループでアイテムコード']);
            return false;
        }
      }
    }
    // 値引情報の正当性チェックを行う
    for (const c of this.kymw0908Model.couponApplicablePriceList) {
      if (!PlessViewUtilsSub.isEmpty(c.discountUnitPrice)) {
        // 値引単価が入力されているかつ値引単価>供給単価の場合
        if (Number(c.discountUnitPrice) > Number(PlessViewUtilsSub.editPriceComma(c.thisTimeSupplyPrice, false))) {
          this.dialogServiceSub.openAlertGetMessage('E0578', ['値引単価には供給単価を超える金額']);
          return false;
        }
      } else if (!PlessViewUtilsSub.isEmpty(c.discountRate)) {
        // 値引率が入力されているかつ値引率が1～100の範囲外の場合
        if (!(Number(c.discountRate) > 0 && Number(c.discountRate) <= 100)) {
          this.dialogServiceSub.openAlertGetMessage('E0614', null);
          return false;
        }
      }
    }
    // 利用都県の正当性チェックを行う
    // 利用都県のチェックがOFFのリストを格納
    const falseFlgList = this.kymw0908Model.couponApplicablePriceList.filter(_ => !_.planGoodsCoopCouponApplicablePriceFlg);
    // 利用都県のチェックボックスが全てOFFの場合
    if (falseFlgList.length === this.kymw0908Model.couponApplicablePriceList.length) {
      this.dialogServiceSub.openAlertGetMessage('E0105', ['利用都県']);
      return false;
    }

    return true;
  }

  /**
   * 値引単価/値引率(%)ラジオボタン選択処理
   * 
   */
  public eventCouponDiscountType_CLICKHandler(): void {
    if (this.kymw0908Model.couponDiscountType === '1') {
      // 値引単価の場合
      this.kymw0908Model.couponDiscountRate = '';
    } else {
      // 値引率(%)の場合
      this.kymw0908Model.couponDiscountUnitPrice = '';
    }
  }

  /**
   * 値引情報一括設定ボタン選択処理
   * 
   */
  public eventCouponDiscountTypeSetting_CLICKHandler(): void {
    const checkedItemList = this.kymw0908Model.couponApplicablePriceList.filter(v => v.planGoodsCoopCouponApplicablePriceFlg);
    const coopIndexList = this.getCoopCheckbox();
    if (this.kymw0908Model.couponDiscountType === '1') {
      // 値引単価の場合
      checkedItemList.forEach((item) => {
        item.discountUnitPrice = this.kymw0908Model.couponDiscountUnitPrice;
        item.discountRate = '';
        if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponDiscountUnitPrice)) {
          item.discountedUnitPrice = '';
        } else {
          const discountUnitPriceNum = PlessViewUtilsSub.stringToNumber(this.kymw0908Model.couponDiscountUnitPrice);
          const supplyPrice = PlessViewUtilsSub.stringToNumber(
            PlessViewUtilsSub.editPriceComma(item.thisTimeSupplyPrice, false)
          );
          const discountedUnitPrice = PlessViewUtilsSub.numberToString(supplyPrice - discountUnitPriceNum);
          item.discountedUnitPrice = PlessViewUtilsSub.editPriceComma(discountedUnitPrice, true);
        }
      });

      if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
        this.kymw0908Model.contentThree = '';
        this.kymw0908Model.contentFour = '';
      } else {
        const item = this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndexList[0]);
        if (PlessViewUtilsSub.isEmpty(item.discountUnitPrice)) {
          this.kymw0908Model.contentThree = '';
          this.kymw0908Model.contentFour = '';
        } else {
          // 値引後単価
          const discountedUnitPriceNum = PlessViewUtilsSub.stringToNumber(
            PlessViewUtilsSub.editPriceComma(item.discountedUnitPrice, false)
          );
          // 値引内容
          if (!PlessViewUtilsSub.isEmpty(item.discountUnitPrice)) {
            this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountUnitPrice) + KYMW0908Model.DISCOUNT_UNIT_PRICE_SUFFIX;
          } else if (!PlessViewUtilsSub.isEmpty(item.discountRate)) {
            this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountRate) + KYMW0908Model.DISCOUNT_RATE_SUFFIX;
          }
          // 消費税
          const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0908Model.consumeTaxDivRate) * 0.01;
          // 値引き後本体価格・税込み価格
          this.kymw0908Model.contentFour = this.kymw0908Model.formatUnitRatePrice(discountedUnitPriceNum, consumeTaxDivRate);
        }
      }
    } else {
      // 値引率(%)の場合
      checkedItemList.forEach((item) => {
        item.discountRate = this.kymw0908Model.couponDiscountRate;
        item.discountUnitPrice = '';
        if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponDiscountRate)) {
          item.discountedUnitPrice = '';
        } else {
          const discountRateNum = PlessViewUtilsSub.stringToNumber(this.kymw0908Model.couponDiscountRate);
          const supplyPrice = PlessViewUtilsSub.stringToNumber(
            PlessViewUtilsSub.editPriceComma(item.thisTimeSupplyPrice, false)
          );
          // 小数点以下は切り上げ
          const discountedUnitPrice = PlessViewUtilsSub.numberToString(
            Math.ceil((1 - (discountRateNum / 100)) * supplyPrice)
          );
          item.discountedUnitPrice = PlessViewUtilsSub.editPriceComma(discountedUnitPrice, true);
        }
      });

      const item = this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndexList[0]);
      if (PlessViewUtilsSub.isEmpty(item.discountRate)) {
        this.kymw0908Model.contentThree = '';
        this.kymw0908Model.contentFour = '';
      } else {
        // 値引後単価
        const discountedUnitPriceNum = PlessViewUtilsSub.stringToNumber(
          PlessViewUtilsSub.editPriceComma(item.discountedUnitPrice, false)
        );
        // 値引内容
        if (!PlessViewUtilsSub.isEmpty(item.discountUnitPrice)) {
          this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountUnitPrice) + KYMW0908Model.DISCOUNT_UNIT_PRICE_SUFFIX;
        } else if (!PlessViewUtilsSub.isEmpty(item.discountRate)) {
          this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountRate) + KYMW0908Model.DISCOUNT_RATE_SUFFIX;
        }
        // 消費税
        const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0908Model.consumeTaxDivRate) * 0.01;
        // 値引き後本体価格・税込み価格
        this.kymw0908Model.contentFour = this.kymw0908Model.formatUnitRatePrice(discountedUnitPriceNum, consumeTaxDivRate);
      }
    }
    this.dtg_CouponApplicablePriceList.editableCollectionView.refresh();
  }

  /**
   * 制限数一括設定ボタン選択処理
   */
  public eventCouponLimitNumSetting_CLICKHandler(): void {
    const checkedItemList = this.kymw0908Model.couponApplicablePriceList.filter(v => v.planGoodsCoopCouponApplicablePriceFlg);
    checkedItemList.forEach((item) => {
      item.limitNum = this.kymw0908Model.couponLimitNum;
    });

    this.dtg_CouponApplicablePriceList.editableCollectionView.refresh();
  }

  /**
   * 会員生協別割引情報一覧.チェック処理
   */
  public eventcouponApplicablePriceListChk_CLICKHandler(): void {
    const coopIndexList = this.getCoopCheckbox();
    if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
      this.kymw0908Model.contentTwo = '';
      this.kymw0908Model.contentThree = '';
      this.kymw0908Model.contentFour = '';
    } else {
      const item = this.kymw0908Model.couponApplicablePriceList.find(_ => _.coopCode === coopIndexList[0]);
      if (PlessViewUtilsSub.isEmpty(item.discountUnitPrice) && PlessViewUtilsSub.isEmpty(item.discountRate)) {
        this.kymw0908Model.contentTwo = '';
        this.kymw0908Model.contentThree = '';
        this.kymw0908Model.contentFour = '';
      }
      // 供給単価
      const supplyPrice = PlessViewUtilsSub.stringToNumber(
        PlessViewUtilsSub.editPriceComma(item.thisTimeSupplyPrice, false)
      );
      // 値引後単価
      const discountedUnitPriceNum = PlessViewUtilsSub.stringToNumber(
        PlessViewUtilsSub.editPriceComma(item.discountedUnitPrice, false)
      );
      // 消費税
      const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0908Model.consumeTaxDivRate) * 0.01;
      // 値引き前本体価格・税込み価格
      this.kymw0908Model.contentTwo = this.kymw0908Model.formatUnitRatePrice(supplyPrice, consumeTaxDivRate);
      // 値引き後本体価格・税込み価格
      this.kymw0908Model.contentFour = this.kymw0908Model.formatUnitRatePrice(discountedUnitPriceNum, consumeTaxDivRate);
      // 値引内容
      if (!PlessViewUtilsSub.isEmpty(item.discountUnitPrice)) {
        this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountUnitPrice) + KYMW0908Model.DISCOUNT_UNIT_PRICE_SUFFIX;
      } else if (!PlessViewUtilsSub.isEmpty(item.discountRate)) {
        this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountRate) + KYMW0908Model.DISCOUNT_RATE_SUFFIX;
      }
    }
  }

  /**
   * 会員生協別割引情報一覧.値引単価フォーカスアウト処理
   */
  public eventDiscountUnitPrice_FOCUS_OUTHandler(item: any): void {
    const coopIndexList = this.getCoopCheckbox();
    if (PlessViewUtilsSub.isEmpty(item.discountUnitPrice)) {
      if (PlessViewUtilsSub.isEmpty(item.discountRate)) {
        item.discountedUnitPrice = '';
        if (!PlessViewUtilsSub.isEmptyArray(coopIndexList) && item.coopCode === coopIndexList[0]) {
          this.kymw0908Model.contentThree = '';
          this.kymw0908Model.contentFour = '';
        }
        this.dtg_CouponApplicablePriceList.editableCollectionView.refresh();
      }
      return;
    }
    // 値引率(%)をクリア
    item.discountRate = '';

    const discountUnitPriceNum = PlessViewUtilsSub.stringToNumber(item.discountUnitPrice);
    const supplyPrice = PlessViewUtilsSub.stringToNumber(
      PlessViewUtilsSub.editPriceComma(item.thisTimeSupplyPrice, false)
    );
    const discountedUnitPriceNum = supplyPrice - discountUnitPriceNum
    item.discountedUnitPrice = PlessViewUtilsSub.editPriceComma(
      PlessViewUtilsSub.numberToString(discountedUnitPriceNum),
      true
    );
    this.dtg_CouponApplicablePriceList.editableCollectionView.refresh();

    if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
      this.kymw0908Model.contentThree = '';
    } else if (item.coopCode === coopIndexList[0]) {
      // 入力した項目がチェックボックスONになっている中で優先度最大だった場合、値引内容と値引き後本体価格・税込み価格を設定する
      this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountUnitPrice) + KYMW0908Model.DISCOUNT_UNIT_PRICE_SUFFIX;
      const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0908Model.consumeTaxDivRate) * 0.01;
      this.kymw0908Model.contentFour = this.kymw0908Model.formatUnitRatePrice(discountedUnitPriceNum, consumeTaxDivRate);
    }
  }

  /**
   * 会員生協別割引情報一覧.値引率フォーカスアウト処理
   */
  public eventDiscountRate_FOCUS_OUTHandler(item: any): void {
    const coopIndexList = this.getCoopCheckbox();
    if (PlessViewUtilsSub.isEmpty(item.discountRate)) {
      if (PlessViewUtilsSub.isEmpty(item.discountUnitPrice)) {
        item.discountedUnitPrice = '';
        if (!PlessViewUtilsSub.isEmptyArray(coopIndexList) && item.coopCode === coopIndexList[0]) {
          this.kymw0908Model.contentThree = '';
          this.kymw0908Model.contentFour = '';
        }
        this.dtg_CouponApplicablePriceList.editableCollectionView.refresh();
      }
      return;
    }
    // 値引単価をクリア
    item.discountUnitPrice = '';

    const discountRateNum = PlessViewUtilsSub.stringToNumber(item.discountRate);
    const supplyPrice = PlessViewUtilsSub.stringToNumber(
      PlessViewUtilsSub.editPriceComma(item.thisTimeSupplyPrice, false)
    );

    const discountedUnitPriceNum = Math.ceil((1 - (discountRateNum / 100)) * supplyPrice);
    item.discountedUnitPrice = PlessViewUtilsSub.editPriceComma(
      PlessViewUtilsSub.numberToString(discountedUnitPriceNum),
      true
    );
    this.dtg_CouponApplicablePriceList.editableCollectionView.refresh();

    if (PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
      this.kymw0908Model.contentThree = '';
    } else if (item.coopCode === coopIndexList[0]) {
      // 入力した項目がチェックボックスONになっている中で優先度最大だった場合、値引内容と値引き後本体価格・税込み価格を設定する
      this.kymw0908Model.contentThree = PlessViewUtilsSub.toFullWidth(item.discountRate) + KYMW0908Model.DISCOUNT_RATE_SUFFIX;
      const consumeTaxDivRate = PlessViewUtilsSub.stringToNumber(this.kymw0908Model.consumeTaxDivRate) * 0.01;
      this.kymw0908Model.contentFour = this.kymw0908Model.formatUnitRatePrice(discountedUnitPriceNum, consumeTaxDivRate);
    }
  }

  /**
   * クーポン名・クーポン規格名変更イベントリスナ
   */
  public couponNameCouponGuideName_CHANGEHandler(): void {
    if (!this.isComposing) {
      if (!PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponName) && !PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponGuideName)) {
        // クーポン名、クーポン規格名を両方入力されている場合「　（全角スペース)」つなぎで連結して表示する
        // ※クーポン名、クーポン規格名の前後に元々空白が入っていた場合は取り除く
        this.kymw0908Model.contentOne = this.kymw00Model.deleteStartAndEndSpace(this.kymw0908Model.couponName) + '　' + this.kymw00Model.deleteStartAndEndSpace(this.kymw0908Model.couponGuideName);
      } else if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponName)) {
        // クーポン規格名のみ入力済みの場合：クーポン規格名を表示する
        // ※クーポン規格名の前後に元々空白が入っていた場合は取り除く
        this.kymw0908Model.contentOne = this.kymw00Model.deleteStartAndEndSpace(this.kymw0908Model.couponGuideName);
      } else if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponGuideName)) {
        // クーポン名のみ入力済みの場合：クーポン名を表示する
        // ※クーポン名の前後に元々空白が入っていた場合は取り除く
        this.kymw0908Model.contentOne = this.kymw00Model.deleteStartAndEndSpace(this.kymw0908Model.couponName);
      } else if (PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponName) && PlessViewUtilsSub.isEmpty(this.kymw0908Model.couponGuideName)) {
        // クーポン名、クーポン規格名が未入力の場合：空欄とする
        this.kymw0908Model.contentOne = '';
      }

      // 全角スペース埋めを行う
      this.kymw0908Model.contentOne = this.parent.contentOneSpacePadding(this.kymw0908Model.contentOne);
    }
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 日本語入力を即時反映するためのメソッド
  onCompCouponNameEnd(e: CompositionEvent) {
    this.isComposing = false;
    this.kymw0908Model.couponName = (e.target as HTMLInputElement).value;
    this.couponNameCouponGuideName_CHANGEHandler();
  }
  onCompCouponGuideNameEnd(e: CompositionEvent) {
    this.isComposing = false;
    this.kymw0908Model.couponGuideName = (e.target as HTMLInputElement).value;
    this.couponNameCouponGuideName_CHANGEHandler();
  }

  /**
   * タイトル（お届け明細）設定メソッド
   */
  public setCouponTitleDelivery(): void {
    // 通知有無区分＝'1'（通知あり）かつ、通知方法区分（お届け明細）＝tureの場合
    if (this.kymw0908Model.notificationFlg === '1' && this.kymw0908Model.deliveryFlg) {
      // ONに変更時
      // 優先順のクーポン対象（チェックボックスがON）の生協を取得
      const coopIndexList = this.getCoopCheckbox();
      if (!PlessViewUtilsSub.isEmptyArray(coopIndexList)) {
        // チェックがついている生協が最低でも一つある場合
        for (const c of coopIndexList) {
          const price = this.kymw0908Model.couponApplicablePriceList.find(cap => {
            // 優先度高の生協で値引き後単価が表示されているものを使用
            if (cap.coopCode === c && !PlessViewUtilsSub.isEmpty(cap.discountedUnitPrice)) {
              return true;
            }
          });
          if (price) {
            if (!PlessViewUtilsSub.isEmpty(price.limitNum) && price.limitNum > 0 &&
              (Number(price.discountUnitPrice) > 0 || Number(price.discountRate) > 0)) {
              // 優先生協の「制限数」が「空欄以外かつ0より大きい数値」かつ、
              // 優先生協の「値引単価または値引率が0より大きい数値」の場合
              this.kymw0908Model.couponTitleDelivery = this.kymw0908Model.formatCouponTitleDelivery(price.limitNum);
              break;
            } else {
              // 優先生協の「制限数」が「空欄または 0」の場合
              this.kymw0908Model.couponTitleDelivery = '';
              break;
            }
          } else {
            // 値引き後単価が空（値引単価と値引率が空）の場合空欄
            this.kymw0908Model.couponTitleDelivery = '';
          }
        }
      } else {
        // 全ての生協のチェックボックスがOFFの場合は、「タイトル(お届け明細)」を空欄にする。
        this.kymw0908Model.couponTitleDelivery = '';
      }
    } else {
      // OFFに変更時
      // 「タイトル(お届け明細)」を空欄にする
      this.kymw0908Model.couponTitleDelivery = '';
    }
  }

  /**
   * クーポン名(カナ)の入力から半角カンマを削除
   */
  public eventCouponNameKana_deleteCommaHandler(): void {
    this.kymw0908Model.couponNameKana = this.kymw0908Model.couponNameKana.replace(/,/g, '');
    // 画面に反映
    this.txti_CouponNameKana.nativeElement.value = this.kymw0908Model.couponNameKana;
  }

  /**
   * クーポン規格名(カナ)の入力から半角カンマを削除
   */
  public eventCouponGuideNameKana_deleteCommaHandler(): void {
    this.kymw0908Model.couponGuideNameKana = this.kymw0908Model.couponGuideNameKana.replace(/,/g, '');
    // 画面に反映
    this.txti_CouponGuideNameKana.nativeElement.value = this.kymw0908Model.couponGuideNameKana;
  }
}
